import { render, staticRenderFns } from "./CardSimple.vue?vue&type=template&id=ba0d0fc0&scoped=true"
import script from "./CardSimple.vue?vue&type=script&lang=js"
export * from "./CardSimple.vue?vue&type=script&lang=js"
import style0 from "./CardSimple.vue?vue&type=style&index=0&id=ba0d0fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0d0fc0",
  null
  
)

export default component.exports